import Util from '@services/util';

const isDevelopmentMode = Util.isDevelopmentMode();

// eslint-disable-next-line no-console
const log = (...args: string[]): any => isDevelopmentMode && console.log(...args);

// eslint-disable-next-line no-console
const warn = (...args: string[]): any => isDevelopmentMode && console.warn(...args);

// eslint-disable-next-line no-console
const error = (...args: string[]): any => isDevelopmentMode && console.error(...args);

export default {
  log,
  warn,
  error,
};
